export const STATUS_META = {
  received: { label: "Order Received", color: "#A855F7" },
  processing: { label: "Processing", color: "#F59E0B" },
  scanning: { label: "Scanning", color: "#06B6D4" },
  printing: { label: "Printing", color: "#3B82F6" },
  shipped: { label: "Shipped", color: "#059669" },
  ready_for_pickup: { label: "Ready for Pickup", color: "#10B981" },
};

export const meta = (s) => STATUS_META[s] || { label: s, color: "#A0A5B1" };
